import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import Topbar from './Topbar';
import Footer from './Footer';
import MobileNav from './MobileNav';

const MainLayout = () => {
  return (
    <Flex direction="column" flex="1">
        <Topbar scrollContainerId="scrollableBody"/>
        <Box as="main" bg="bg.muted" h="100vh" overflow="auto" id="scrollableBody" >
          <Outlet />
          <Footer />
        </Box>
        <MobileNav />
        
    </Flex>
  );
};

export default MainLayout;
